<script setup>
/**
 * Is the inner slot of a button component.
 * Displays a loading spinner or a checkmark when the button is processing or recently successful.
 * Assumes a relative parent.
 */
defineProps({
    processing: Boolean,
    recentlySuccessful: Boolean,
});
</script>

<template>
    <span :class="{ 'opacity-0': processing || recentlySuccessful }" class="w-full duration-300 transform-all">
        <slot></slot>
    </span>

    <span
        :class="{ 'opacity-100': recentlySuccessful }"
        class="absolute duration-300 transform -translate-x-1/2 -translate-y-1/2 opacity-0 top-1/2 left-1/2"
    >
        <svg xmlns="http://www.w3.org/2000/svg" width="22.161" height="15.999" viewBox="0 0 22.161 15.999">
            <path
                d="M15.325,28.2,7.7,20.574,9.164,19.11l6.161,6.162L28.4,12.2l1.464,1.464Z"
                transform="translate(-7.7 -12.2)"
                fill="currentColor"
            />
        </svg>
    </span>
    <span
        :class="{ 'opacity-100': processing }"
        class="absolute duration-300 transform -translate-x-1/2 -translate-y-1/2 opacity-0 top-1/2 left-1/2"
    >
        <svg class="w-5 h-5 text-blue animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
    </span>
</template>
